import { combineReducers } from 'redux';

import searchReducer from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/interventions/actionTypes';

import filters from './filters';
import modal from './modal';

/**
 * @typedef {{
 *   modal : import('./modal').MobilityModalReducer,
 *   filters: import('./filters').MobilityFiltersReducer,
 *   data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} MobilityReducer
 */

export default combineReducers({
  modal,
  filters,
  data: searchReducer(types.FETCH_MOBILITY_INTERVENTIONS, {
    global: {
      paginationSlice: true,
      matcher: ({ meta }) => meta.source === 'mobility-dashboard',
    },
  }),
});
